import React, { useState, useEffect } from 'react';
// import { Link,  useHistory } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import editIcon from '../assets/images/edit.png';
import deleteIcon from '../assets/images/delete.png';
// import defaultLogo from '../assets/images/logo11.png';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import SavedCard from "../components/TemplateCard";

// Redux Store
import { connect } from "react-redux";

// Components 
import SelectTemplate from '../components/MyTemplateSteps/selectTemplate';
import EditTemplate from '../components/MyTemplateSteps/editTemplate';
import TemplateCategory from '../components/MyTemplateSteps/category';
import PreviewTemplate from '../components/MyTemplateSteps/preview';
import PublishTemplate from '../components/MyTemplateSteps/publish';
import Uploader from '../components/misc/uploader';

import { Row, Col, Card, message, Form, Input, Select, Button, Divider, Steps, Radio, notification } from 'antd';
import { ArrowRightOutlined, ArrowLeftOutlined } from "@ant-design/icons";

import { EventEmitter } from '../events.js';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllTemplates, createCard, setCards, publishCardList, resetSelected, getGiveBackCampaigns, 
listCardCategories, setcurrent, setTemplateInfo, emtpySavedCards } from "../store/cards/cards.actions";

const { Step } = Steps;
const { Option } = Select;

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000
};

const AddCard = (props) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    let history = useHistory();
    const { current, selected, eCards, campaigns, edit } = useSelector(state => state.cards);
    const { data }  = useSelector(state => state.user);
    const [loading, setloading] = useState(false);
    const [save, setSave] = useState(false);
    const [view, setView] = useState('template');
    // const [current, setcurrent] = useState(0);
    const [formData, setformData] = useState({
        image: null,
        title: null,
        amount: null,
        category: null,
        occasion: null,
        promotion: false,
        description: null
    });
    const [promoImg, setpromoImg] = useState(null);
    const [category, setcategory] = useState(null);
    const [error, seterror] = useState();
    const [published, setPublished] = useState(0);
    
    const onFinish = async () => {
        setloading(true);
        
        await form.validateFields()
        
        const cardInfo = Object.assign({}, form.getFieldsValue())
        console.log('Form Initial:', cardInfo)
        cardInfo.image = promoImg
        cardInfo.logo = "N/A"
        cardInfo.company_code = data.person.companies[0].code
        cardInfo.web_design_props = {
            logo_position: ["bottom", "right"],
            default_color: "black",
            font_weight: "normal"
        }
        cardInfo.person_id = data.person.person_id
        cardInfo.state = 'published'   
        cardInfo.card_style = `<div style="position: relative; display: flex; justify-content: space-between; border-width: 0px; background-color: transparent;"><div style="width: 100%; display: flex; flex-direction: column; align-items: center; margin-left: auto; margin-right: auto; position: relative;"><img id="tempId" src="${promoImg}" alt="" style="width: 50%;"><div style="position: absolute; width: 50%; height: 100%;"><div style="color: rgb(255, 255, 255); font-size: 1rem; position: absolute; top: 0px; right: 0px; padding: 1rem;">${cardInfo.amount}</div><div class=" bottom-0 right-0 absolute p-4"><img src="https://primeegiftfiles.s3.us-east-2.amazonaws.com/prime-images/PZQ_logo11.png" alt="" style="width: 2.5rem; margin-left: auto; margin-right: auto;"></div></div></div></div>"`
        cardInfo.card_category_id = 25
        cardInfo.promo_description = cardInfo.description
        console.log('Form Final Data:', cardInfo);

        dispatch(createCard(cardInfo))
        .then(res => { setloading(false);
                switch (res.status) {
                    case 201:
                        message.success("Card Created successfully");
                        break;
                    case 400:
                    message.error(res.error_msg);
                        break;

                    default:
                        break;
                }
            }, err => {
                message.error("Card Couldn't be created");     
                console.log('Error:', err)
                setloading(false);
            }
        );
    };
    const handleInput = (val) => {
        console.log('Value:', val);
		setformData({
			...formData,
			[Object.keys(val)[0]]: Object.values(val)[0]
		});	        
    };
    const publish = () => {
        setloading(true);
        // console.log('FormData:', formData);
        const cardInfo = Object.assign({}, formData);
        
        cardInfo.web_design_props = {
            logo_position: ['bottom', 'left'],
            default_color: "white",
            font_weight: "normal"
        }

    cardInfo.person_id = data.person.person_id
    // let style = cardInfo.card_style;
    // cardInfo.card_style = {}
    // cardInfo.card_style.styles = style
    cardInfo.card_category_id = 9
    cardInfo.state = 'published'
        // Perform request here
		// form.validateFields()
		dispatch(createCard(cardInfo))
		.then(
			res => { 
                setloading(false);
                console.log('Res:', res);
                message.success("Card Created successfully");             
            },
            err => {
                message.error('Card could not be created, try again');
            }
		);      
    };
    const steps = [
        {
            title: 'Select Template',
        },
        {
            title: 'Edit Template',
        },
        {
            title: 'Category',
        },
        {
            title: 'Preview & Save',
        },
        {
            title: 'Publish',
        },
    ];
    const next = async () => {
        if (props.selected === null ) {
            message.warning("Please Select A Template");
        } else {
            // dispatch(setcurrent(current + 1));

            // Perform form validations here!!
            switch (current) {
                case 1:
                    EventEmitter.dispatch('checkEditTemplate')
                break;
                case 2:
                    EventEmitter.dispatch('checkCategoryTemplate')                 
                break;

                default:
                    dispatch(setcurrent(current + 1));
                break;
            };
              
        }
    };
    const prev = () => {
        if (current > 0) dispatch(setcurrent(current - 1));
    };
    const handleOnChange = current => {
        console.log('onChange:', current);
        // if(current) setcurrent(current)
    };  
    const handleCreateCard = (type="published") => {
        setloading(true);
        console.log('Selected Card:', selected);
        
        const cardInfo = Object.assign({}, selected)
        cardInfo.company_code = data?.person?.companies[0]?.code
        
        cardInfo.web_design_props = {
            logo_position: cardInfo.logo_position,
            amount_position: ["top", "right"],
            default_color: cardInfo.default_color,
            font_weight: cardInfo.font_weight,
            show_amount: cardInfo.show_amount,
        }

        if (cardInfo.type) cardInfo.web_design_props.type = cardInfo.type
        
        cardInfo.person_id = data.person.person_id
        cardInfo.state = type;
        
        if (cardInfo.expiry_date === null) delete cardInfo.expiry_date
        if (cardInfo.logo === "") cardInfo.logo = null
        if (cardInfo.card_category_id === 30) delete cardInfo.card_category_id
        if (!cardInfo.card_category_id) delete cardInfo.card_category_id

        if (cardInfo.is_update) {
            delete cardInfo.mobile_design_props;
            delete cardInfo.ussd_design_props;
            cardInfo.card_id = cardInfo.id
            // cardInfo.state = null

            if (type === "draft") {
                dispatch(setCards(cardInfo))
                // .then(() => {
                //     setSave(false);
                // })
                setTimeout(() => {
                    setSave(false);
                    setloading(false);
                }, 1000);
                message.success('Card saved in draft list');  
            } else {
                dispatch(createCard(cardInfo, "UPDATE"))
                .then(res => {
                    setloading(false);
                        switch (res.status) {
                            case 200:
                                history.push("/cards")
                                notification.success({
                                    message: 'Card Updated',
                                    duration: 5,
                                    description: <p>Card updated successfully</p>,
                                });
                            break;
    
                            case 400:
                                message.error(res.error_msg);
                            break;
        
                            default:
                            break;
                        }
                    }, err => {
                        message.error("Card update failed");     
                        setloading(false);
                })
            }
        } else {
            if (type === "draft") {    
                dispatch(createCard(cardInfo))
                .then(res => {
                    console.log('Creating a draft card:', res.data);

                    setloading(false);
                    // setSave(false);
                    const { status } = res; 
                    console.log('Status:', status);
    
                    switch (status) {
                        case 201:
                            if (res.data.success) {
                                if (type === "draft") {
                                    message.success('Card saved in draft list');
                                    setSave(false);
                                }
                            }

                            const TempCard = Object.assign({}, cardInfo);
                            TempCard.template_id = cardInfo.id
                            TempCard.id = res.data?.data?.card?.id
                            dispatch(setTemplateInfo('id', res.data?.data?.card?.id));

                            console.log('Final editing card:', TempCard);

                            dispatch(setCards(TempCard))

                            break;
                        case 401:
                            message.error(res.error_msg);
                            setSave(false);
                            break;
                        case 400:
                            message.error(res.error_msg)
                            setSave(false);
                            break;
                        case 404:
                            message.error(res.error_msg)
                            setSave(false);
                            break;
                        default:
                            setSave(false);
                        break;
                    }              
                });
            } else {
                if (eCards.length > 1) {
                    let card_ids = [];

                    const isSelectedSaved = eCards.find(el => el.id === selected.id);

                    if (!isSelectedSaved) {
                        console.log('Selected not found in saved')
                        dispatch(createCard(cardInfo))
                        .then((res) => {
                            const { status } = res;
                            switch (status) {
                                case 201:
                                    const TempCard = Object.assign({}, cardInfo);
                                    TempCard.template_id = cardInfo.id
                                    TempCard.id = res.data?.data?.card?.id

                                    dispatch(setCards(TempCard))
                                    .then((selectedInfo) => {
                                        card_ids.push(selectedInfo?.id);
                                        processPublishList(card_ids)
                                    })
                                break;
                                default:
                                break;
                            }
                        })
                    } else {
                        processPublishList(card_ids);
                    }
                }
                else {
                    if (eCards.length > 0) {
                        console.log('Updating card info, from eCards Saved!', cardInfo)
                        delete cardInfo.mobile_design_props;
                        delete cardInfo.ussd_design_props;
                        cardInfo.card_id = cardInfo.id
                    }

                    dispatch(createCard(cardInfo, eCards.length>0?"UPDATE":"ADD"))
                    .then(res => {
                        setloading(false);
                        const { status } = res; 
                        console.log('Status:', status);
        
                        switch (status) {
                            case 201:
                                if (res.data.success) {
                                    if (type === "draft") {
                                        message.success("Card Saved successfully");
                                        setSave(false);
                                    }
                                    else {
                                        message.success("Card(s) Published Successfully");
                                        next()
                                    }
                                } else {
                                    console.log('what is here?', res.data.error);
                                }					
                                break;
                                case 200:
                                    message.success("Card Published Successfully");
                                    next()
                                break;                                
                            case 401:
                                message.error(res.error_msg);
                                break;
                            case 400:
                                message.error(res.error_msg)
                                break;
                            case 404:
                                message.error(res.error_msg)
                                break;
                            default:
                                break;
                        }              
                    });
                }
            }
        }

        function processPublishList(card_ids) {
            console.log('Available Card Length:', eCards.length);

            eCards.forEach(el => {
                card_ids.push(el.id)
            });

            let ID = data.person.companies[0].code;
            dispatch(publishCardList({card_ids: card_ids}, "ADD", ID))
            .then(res => {
                setloading(false);
                const { status } = res; 
                console.log('Status:', status);

                switch (status) {
                    case 201:
                        if (res.data.success) {
                            message.success("Card Created successfully");
                            setPublished(eCards.length)
                            dispatch(emtpySavedCards())
                            .then(() => {
                            })
                            next()
                        } else {
                            console.log('what is here?', res.data.error);
                        }					
                        break;
                    case 401:
                        message.error(res.error_msg);
                        break;
                    case 400:
                        message.error(res.error_msg)
                        break;
                    case 404:
                        message.error(res.error_msg)
                        break;
                    default:
                        break;
                }              
            });            
        }
    };

    const saveCurrentCard = () => {
        setSave(true);
        handleCreateCard("draft");
    };
    const createNewCard = () => {
        dispatch(setcurrent(0))
        // setCreate(true);
        setTimeout(() => {
            // setCreate(false);
            dispatch(resetSelected())
        }, 2000);
    };  
    const getUploadedImage = (imageUrl) => {
        setformData(
            prevState => {
                return { ...prevState, 'image': imageUrl }
            }
        )
        setpromoImg(imageUrl)   
    };
    const handleCatSelection = (e) => {
        setcategory(e)
    };
    const handleOtherCategory = (e) => {
        // let other = e.target.value;
        form.setFieldsValue({category: e.target.value})
        // console.log('Other:', form.getFieldValue("category"))
    };

    // useEffect(() => {
    //     window.scrollTo(0, 0);
    // }, [current]);  

    useEffect(() => {
        if (edit) {
            dispatch(setcurrent(1))
        }
    }, [edit]);

    // useEffect(() => {
    //     if (current === 0 && selected !== null) {
    //         dispatch(setSetlectedTemplate({}, null))
    //     }
    // }, []);

    useEffect(() => {
        dispatch(fetchAllTemplates())
        dispatch(getGiveBackCampaigns())
        dispatch(listCardCategories())      
    }, []);

    return (
        <>
            {campaigns.length > 0 && 
                <Slider {...settings} className="ads mb-6 bg-gray-200">
                    {campaigns.map((ad, index) => (
                        <div className="border border-primary" key={index}>
                            <img 
                                src={ad.images.length > 0 && ad.images[0].url} 
                                className="h-64 w-full object-cover" 
                                alt="" 
                            />
                            <div className="bg-primary flex justify-between py-4 px-6">
                                <div className="text-white flex items-center">{ad.name}</div>
                                <div className="pl-2">
                                    <Button className="bg-secondary rounded-full text-white py-1 z-50">
                                        <a href={ad.website || '#'} target="_blank" rel="noopener noreferrer">More details</a>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            }

            {view === 'design' &&
                <>
                    <div className="text-center">
                        <h1 className="font-bold mb-1 text-lg">
                            Give the world the opportunity to show their love
                        </h1>
                        <div className="font-normal text-sm leading-normal">
                            <div>Upload a jpg or png file of your already designed e-gift card</div>
                            <div>Save when done and click <b>publish</b> to go live</div>
                        </div>
                    </div>

                    <Row className="my-6">
                        <Col span={8} className="">
                            <Uploader 
                                uploadImage={getUploadedImage} 
                                classStyle={promoImg && "opacity-75 my-1 h-40 bg-cover bg-no-repeat"}
                                bg={promoImg}
                                uploadText={promoImg ? '' : 'Upload Card Image'}
                            />
                            <span>{error}</span>
                            <div className="bg-primary my-6 p-6 rounded-lg">
                                <Form
                                    name="addCard"
                                    form={form}
                                    className="w-full addCard"
                                    layout="vertical"
                                    onValuesChange={handleInput}
                                    onFinish={onFinish}
                                >
                                    <Form.Item name="title" label="Name of E-Card" rules={[{
                                        required: true,
                                        message: 'Please provide a card name',
								    }]}
                                    >
                                        <Input placeholder="Name" className="rounded bg-white" />
                                    </Form.Item>
                                    <Form.Item name="amount" label="Amount" rules={[{
                                        required: true,
                                        message: 'Please provide an amount',
								    }]}
                                    >
                                        <Input placeholder="GHS 24.99" className="rounded bg-white" />
                                    </Form.Item>
                                    <Form.Item
                                        name="category" 
                                        label="Categories" 
                                        rules={[{
                                            required: true,
                                            message: 'Please select at least one category',
                                        }]}
                                    >
                                        <Select
                                            onChange={handleCatSelection}
                                            placeholder="Occassion"
                                            className="rounded bg-white"
                                        >
                                            <Option value="travel">Travel</Option>
                                            <Option value="occasion">Ocassion</Option>
                                            <Option value="other">Other</Option>
                                        </Select>
                                        {category === "other" &&
                                            <Input 
                                                placeholder="Other Category" 
                                                className="rounded bg-white mt-3" 
                                                onChange={handleOtherCategory}
                                            />
                                        }
                                    </Form.Item>
                                    <Form.Item name="occasion" label="Tag Ocassion" rules={[{
                                        required: true,
                                        message: 'Please select an occasion',
								    }]}
                                    >
                                        {/* <Input placeholder="Birthday, Christmas, Valentine" className="rounded bg-white" /> */}
                                        <Select
                                            mode="tags"
                                            placeholder="Birthday, Christmas, Valentine, ..."
                                            className="rounded bg-white"
                                        >
                                            <Option value="birthday">Birthday</Option>
                                            <Option value="wedding">Wedding</Option>
                                            <Option value="valentine">Valentine</Option>
                                            <Option value="christmas">Christmas</Option>
                                            <Option value="festival">Festival</Option>
                                        </Select>                                        
                                    </Form.Item>
                                    <div className="flex--between">
                                        <Form.Item name="promotion" label="Promotion" rules={[{
                                            required: true,
                                            message: "Please specify type of promotion",
                                        }]}
                                        >
                                            <Radio.Group value={formData.promotion} className="flex promo_radio">
                                                <Radio value={true}>Yes</Radio>
                                                <Radio value={false}>No</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                        <div>
                                            {formData.promotion === true &&
                                                <Form.Item name="date" label="Type" rules={[{
                                                    required: true,
                                                    message: 'Please what kind of type',
                                                }]}
                                                >
                                                    <Radio.Group value={formData.promotion} className="flex promo_radio">
                                                        <Radio value={true}>Open</Radio>
                                                        <Radio value={false}>Close</Radio>
                                                    </Radio.Group>
                                                </Form.Item>
                                            }
                                        </div>

                                    </div>
                                    <Form.Item name="description" className="pt-4" rules={[{
                                        required: true,
                                        message: 'Please provide a card name',
								    }]}
                                    >
                                        <Input.TextArea rows={6} placeholder="Enter Promotional Details..." className="rounded bg-white" />
                                    </Form.Item>
                                    <Form.Item className="pt-6">
                                        <div className="flex justify-center">
                                            <Button
                                                htmlType="submit"
                                                type="primary"
                                                className="bg-secondary w-2/3 uppercase font-semibold"
                                                shape="round"
                                                size="large"
                                                loading={loading}
                                                disabled={selected.is_update}
                                            >
                                                SAVE
                                        </Button>
                                        </div>
                                    </Form.Item>
                                </Form>
                            </div>
                        </Col>
                        <Col span={16} className="pl-4">
                            <Card className="rounded-large shadow-lg">
                                <h2 className="text-lg text-primary font-bold pb-4 text-center">
                                    Drafted e-gift cards
                                </h2>
                                {eCards.length < 1 &&
                                    <div className="flex--basic pb-4">
                                        <div>
                                            <svg className="fill-current mx-auto w-20 h-20" width="64" height="64" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clipath="url(#clip0)">
                                                    <path d="M510.244 143.201C508.039 138.251 504.041 134.463 498.984 132.536L288.653 52.3913C280.875 49.4256 272.363 51.5884 266.889 57.1949L262.089 30.1713C260.146 19.2352 249.632 11.9039 238.654 13.8227L93.7357 39.1885C89.656 39.9024 86.9272 43.7891 87.6412 47.8687C88.3551 51.9474 92.2408 54.6741 96.3214 53.9632L241.239 28.5974C244.044 28.1095 246.83 30.0293 247.321 32.7941L255.904 81.1128L235.014 135.135L225.584 81.3958C224.246 72.7725 215.854 65.7952 207.191 67.464L64.7162 92.7708C56.2129 94.2827 50.6044 102.972 52.2143 112.141L97.1903 368.439C98.5382 377.064 106.899 384.034 115.584 382.37L141.166 377.827L136.104 390.919C133.207 398.133 135.084 406.854 140.592 412.313L82.4586 422.488C79.6509 422.976 76.8681 421.056 76.3762 418.291L15.1146 73.4125C14.5746 70.6987 16.6314 67.848 19.3632 67.434L60.3256 60.2636C64.4062 59.5497 67.134 55.663 66.4201 51.5834C65.7061 47.5038 61.8134 44.779 57.7398 45.4889L16.7784 52.6593C6.06235 54.3002 -1.77196 65.4002 0.346851 76.0353L61.6085 420.913C63.5003 431.913 74.3234 439.218 85.0434 437.262L164.449 423.363L358.092 497.148C368.223 501.092 380.219 496.017 384.214 485.563L486.635 220.705C488.129 216.842 486.208 212.499 482.345 211.005C478.482 209.512 474.139 211.432 472.646 215.295L370.225 480.154C369.208 482.784 366.1 484.153 363.434 483.132L153.101 402.987C150.503 402.064 149.043 398.881 150.093 396.327L159.67 371.56C159.927 371.067 160.129 370.546 160.272 370.003L204.086 256.701C205.58 252.839 203.659 248.496 199.796 247.002C195.933 245.509 191.591 247.43 190.097 251.292L147.492 361.468L113.038 367.588C112.765 367.481 112.147 366.895 111.963 365.846L66.987 109.548C66.8 108.486 67.191 107.718 67.416 107.525L209.736 82.2467C210.009 82.3537 210.627 82.9397 210.811 83.9886L224.54 162.223L203.243 217.297C201.749 221.159 203.67 225.502 207.533 226.996C211.296 228.481 215.741 226.607 217.232 222.706L269.816 86.7233C270.561 85.6914 271.043 84.4725 271.189 83.1736L276.521 69.3858C277.538 66.7551 280.647 65.3892 283.312 66.4071L493.644 146.553C496.243 147.477 497.703 150.658 496.654 153.212L485.793 181.299C484.299 185.162 486.22 189.504 490.083 190.998C493.944 192.487 498.288 190.571 499.782 186.709L510.643 158.622C512.581 153.608 512.44 148.133 510.244 143.201V143.201Z" fill="#A2A2B5" />
                                                    <path d="M390.227 220.701C372.303 212.413 355.098 216.503 345.131 220.461C341.072 211.408 332.465 198.053 315.503 191.512C310.327 189.516 292.028 183.742 273.844 193.241V193.242C254.581 203.302 249.107 223.389 246.768 231.968C232.394 284.698 287.834 339.093 294.203 345.122C295.597 346.442 297.443 347.176 299.358 347.176C299.411 347.176 299.464 347.175 299.517 347.174C314.493 346.858 390.333 342.826 412.722 294.48C415.97 287.467 424.597 268.837 417.174 248.922C410.768 231.735 396.196 223.46 390.227 220.701V220.701ZM399.113 288.177C381.578 326.04 318.572 331.335 302.299 332.071C291.121 320.927 250.147 276.605 261.24 235.911C263.218 228.657 267.331 213.563 280.788 206.535C293.72 199.783 307.48 204.493 310.107 205.507C327.962 212.391 333.107 230.601 333.636 232.654C334.716 237.37 340.598 239.812 344.699 237.252C346.753 236.045 365.306 225.704 383.933 234.315C388.217 236.294 398.66 242.194 403.12 254.16C408.358 268.213 402.113 281.695 399.113 288.177V288.177Z" fill="#A2A2B5" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0">
                                                        <rect width="512" height="512" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <div className="font-normal">
                                                No Cards Available
                                            </div>
                                        </div>
                                    </div>
                                }

                                {eCards.map((card, index) => (
                                    <>
                                        <div className="flex" key={index}>
                                            <SavedCard card={card} key={index} />
                                            <div className="pl-4">
                                                <div className="flex items-start">
                                                    <span className="font-bold pr-1">Name: </span><span>{card.name}</span>
                                                </div>
                                                <div className="flex items-start">
                                                    <span className="font-bold pr-1">Amount: </span><span>{card.amount}</span>
                                                </div>
                                                <div className="flex items-start">
                                                    <span className="font-bold pr-1">Category: </span><span>{card.category}</span>
                                                </div>
                                            </div>
                                            <div className="pl-4">
                                                <div className="flex items-start">
                                                    <span className="font-bold pr-1">Tag: </span><span>{card.tag}</span>
                                                </div>
                                                <div className="flex items-start">
                                                    <span className="font-bold pr-1">Promotion: </span><span>{card.promotion}</span>
                                                </div>
                                            </div>
                                            <div className="flex flex-col justify-between pl-4">
                                                <div className="">
                                                    <img src={editIcon} className="w-6" alt="" />
                                                    <span className="text-xs">Edit</span>
                                                </div>
                                                <div>
                                                    <img src={deleteIcon} className="w-6" alt="" />
                                                    <span className="text-xs">Delete</span>
                                                </div>
                                            </div>
                                        </div>
                                        <Divider className="mt-0 mb-4 mt-2" />
                                    </>
                                ))}

                                <div className="flex justify-center pt-4">
                                    <Button
                                        type="primary"
                                        className="bg-primary w-1/3 uppercase font-semibold"
                                        shape="round"
                                        size="large"
                                        loading={loading}
                                        onClick={() => { publish() }}
                                    >
                                        {selected.is_update ?
                                            'Update'
                                        :
                                            'Publish'
                                        }
                                    </Button>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            {view === 'template' &&
                <>
                    {current === 0 &&
                        <div className="text-center">
                            <h1 className="font-bold mb-1 text-lg leading-snug">
                                Select any of the e-card Template or from your library
                            </h1>
                            <div className="font-normal text-sm">
                                <p>Add your logo, Change Amount or upload a new image</p>
                            </div>
                        </div>
                    }
                    {current === 1 &&
                        <div className="text-center">
                            <h1 className="font-bold mb-1 text-lg leading-snug">Give it your look</h1>
                            <div className="leading-snug">
                                Add your logo, Image, change color and add price <br/>
                                You can reposition any element on the card to your customize your design
                            </div>
                        </div>
                    }
                    {current === 2 &&
                        <div className="text-center">
                            <p className="font-bold mb-1 text-lg leading-snug">Details Matter</p>
                            <div className="leading-snug">
                                <p>Let your customer know what its In the promotion</p>
                            </div>
                        </div>
                    }
                    {current === 3 &&
                        <div className="text-center">
                            <p className="font-bold mb-1 text-lg leading-snug">Preview</p>
                            <div className="">
                                <p>Give It a second look before you publish</p>
                            </div>
                        </div>
                    }
                    {current === 4 &&
                        <div className="text-center">
                            <p className="font-bold mb-1 text-lg">You are all set</p>
                            <div className="">
                                <p>Prepare to receive your customers with Joy</p>
                            </div>
                        </div>
                    }

                    <Row className="m-6">
                        <Steps
                            current={current} 
                            onChange={handleOnChange}
                            className="mb-4"
                        >
                            {steps.map(item => (<Step key={item.title} title={item.title} />))}
                        </Steps>
                        <>
                            <Row className="w-full">
                                <Col span={8} offset={16}>
                                    <div className="flex justify-end py-2">
                                        {(current > 0 && current < 4 ) && (
                                            <Button
                                                className="w-1/4 uppercase font-semibold"
                                                shape="round"
                                                size="middle"
                                                onClick={() => { prev() }}
                                            >
                                                <div className="flex--between">
                                                    <ArrowLeftOutlined />
                                                    Prev
                                                </div>
                                            </Button>
                                        )}

                                        {current > 3  && (
                                            <Button
                                                className="px-8 uppercase font-semibold"
                                                shape="round"
                                                size="middle"
                                                onClick={() => { dispatch(setcurrent(0)) }}
                                            >
                                                <div className="flex--between">
                                                    <ArrowLeftOutlined className="mr-4" />
                                                    <span>Start New</span>
                                                </div>
                                            </Button>
                                        )}

                                        {current < steps.length - 2 && (
                                            <Button
                                                type="primary"
                                                className="bg-primary w-1/4 font-semibold text-white mx-4"
                                                shape="round"
                                                size="middle"
                                                onClick={() => { next() }}
                                            >
                                                <div className="flex--between">
                                                    NEXT
                                                    <ArrowRightOutlined />
                                                </div>
                                            </Button>
                                        )}
                                        {current === steps.length - 2 && (
                                            <Button
                                                type="primary"
                                                className="bg-primary w-2/5 font-semibold mx-4"
                                                shape="round"
                                                size="middle"
                                                loading={loading}
                                                onClick={() => {handleCreateCard("published")}}
                                            >
                                                {selected.is_update ?
                                                    'UPDATE'
                                                :
                                                    'PUBLISH'
                                                }
                                            </Button>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            {/* Render all the different stages here */}
                            {current === 0 &&
                                <SelectTemplate val="1" />
                            }
                            {current === 1 &&
                                <EditTemplate val="2" />
                            }
                            {current === 2 &&
                                <TemplateCategory val="3" />
                            }
                            {current === 3 &&
                                <>
                                    <PreviewTemplate val="4" />
                                    <Col span={16} className="pt-8">
                                        <div className="flex--between">
                                            <Button
                                                type="primary"
                                                className="bg-primary w-1/4 font-semibold text-white ml-8 uppercase"
                                                shape="round"
                                                size="middle"
                                                loading={save}
                                                onClick={() => { saveCurrentCard() }}
                                                disabled={selected.is_update}
                                            >
                                                SAVE
                                            </Button>

                                            <Button
                                                type="primary"
                                                className="w-1/4 border-none font-semibold mr-8 text-primary uppercase"
                                                style={{backgroundColor: '#ffb900'}}
                                                shape="round"
                                                size="middle"
                                                onClick={() => { createNewCard() }}
                                                // disabled={eCards.length < 1}
                                            >
                                                Create New
                                            </Button>
                                        </div>
                                    </Col>
                                </>
                            }
                            {current === 4 &&
                                <PublishTemplate val="5" publishedList={published} />
                            }
                        </>
                    </Row>

                    <Row>
                        <Col span={8} offset={16}>
                            <div className="flex justify-end py-2">
                                {(current > 0 && current < 4 ) && (
                                    <Button
                                        className="w-1/4 uppercase font-semibold"
                                        shape="round"
                                        size="middle"
                                        onClick={() => { prev() }}
                                    >
                                        <div className="flex--between">
                                            <ArrowLeftOutlined />
                                            Prev
                                        </div>
                                    </Button>
                                )}

                                {current > 3  && (
                                    <Button
                                        className="px-8 uppercase font-semibold"
                                        shape="round"
                                        size="middle"
                                        onClick={() => { dispatch(setcurrent(0)) }}
                                    >
                                        <div className="flex--between">
                                            <ArrowLeftOutlined className="mr-4" />
                                            <span>Start New</span>
                                        </div>
                                    </Button>
                                )}

                                {current < steps.length - 2 && (
                                    <Button
                                        type="primary"
                                        className="bg-primary w-1/4 font-semibold text-white mx-4"
                                        shape="round"
                                        size="middle"
                                        onClick={() => { next() }}
                                    >
                                        <div className="flex--between">
                                            NEXT
                                            <ArrowRightOutlined />
                                        </div>
                                    </Button>
                                )}
                                {current === steps.length - 2 && (
                                    <Button
                                        type="primary"
                                        className="bg-primary w-2/5 font-semibold mx-4"
                                        shape="round"
                                        size="middle"
                                        loading={loading}
                                        onClick={() => {handleCreateCard("published")}}
                                    >
                                        {selected.is_update ?
                                            'UPDATE'
                                        :
                                            'PUBLISH'
                                        }
                                    </Button>
                                )}
                            </div>
                        </Col>
                    </Row>
                </>
            }
        </>
    )
};

const mapStateToProps = state => {
    return {
      selected: state.cards.selected
    }
};

export default connect(mapStateToProps, null)(AddCard);